import * as React from 'react'
import {connect} from 'react-redux'
import FixedPopupRenderer from '../core/components/PopupRenderers/FixedPopupRenderer'
import {OnClickAction} from '../core/enums/MapEvents'
import {getCookie} from '../core/helpers'
import {
  IFeatureTablesDispatcher,
  IMapDispatcher,
  IPopupDispatcher,
  ISidebarDispatcher,
  ISourcesDispatcher
} from '../core/interfaces/dispatchers'
import {IFeatureLayerInfos} from '../core/interfaces/reducers'
import {IMapService} from '../core/interfaces/services'
import {ServiceHub} from '../core/ServiceHub'
import {appFeatureTablesDispatcher} from '../dispatchers/appFeatureTablesDispatcher'
import {appMapDispatcher} from '../dispatchers/appMapDispatcher'
import {appPopupDispatcher} from '../dispatchers/appPopupDispatcher'
import {appSidebarDispatcher} from '../dispatchers/appSidebarDispatcher'
import {appSourcesDispatcher} from '../dispatchers/appSourcesDispatcher'
import {signOut, tryRecoverCredentials} from '../dispatchers/userInfo'
import {IAppStore, IAppUser} from '../interfaces/reducers'
import appConfig from '../reducers/appConfig'
import {Main} from './ArchImport/Main'
import CodeLayout from './Layouts/CodeLayout/CodeLayout'
import AppHeader from './MainComponents/AppHeader'
import Login from './MainComponents/Login'
import MainContent from './MainComponents/MainContent'
import SidebarContent from './MainComponents/SidebarContent'
import SidebarNavigation from './MainComponents/SidebarNavigation'

declare let webpack: {core: string; production: boolean; configFile: string}
interface DispatchProps
  extends IMapDispatcher, IFeatureTablesDispatcher, IPopupDispatcher, ISidebarDispatcher, ISourcesDispatcher {
  tryRecoverCredentials: typeof tryRecoverCredentials
  signOut: typeof signOut
}

interface OwnProps {
  mobile: boolean
  sourcesImported: boolean
  minimizeSidebar: boolean
  layerInfos: IFeatureLayerInfos
  user?: IAppUser
}

type Props = DispatchProps & OwnProps

interface State {
  mapService?: IMapService
}

class App extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    props.setMapOnClick(OnClickAction.Popup)
    this.state = {}
  }

  recoverAttempted = false
  componentDidUpdate(prevProps: Props) {
    if (prevProps !== this.props) {
      this.stateOrPropsChanged(this.props, this.state)
    }
  }

  stateOrPropsChanged(props: Props, state: State) {
    if (appConfig.admin || appConfig.isArchImport) {
      if (this.state.mapService && !this.recoverAttempted) {
        this.recoverAttempted = true
        props.tryRecoverCredentials(success => {
          if (!success) {
            props.addPopups({
              login: {
                draggableAxis: 'both',
                width: '300px',
                content: <Login />,
                header: <div>Вход в системата</div>,
                closeButton: <div></div>
              }
            })
          }
        })
      }
    } else if (this.state.mapService && !this.recoverAttempted) {
      this.recoverAttempted = true
      ServiceHub.SourcesService.getConfigInfos()
        .then(r => {
          props.dispatchSources(r)
        })
        .catch(error => {
          console.error('Failed to load sources:', error)
        })
    }
  }

  getContent() {
    const cookieSidebarWidth = getCookie('sidebarWidth')
    if (appConfig.admin) {
      return (
        <CodeLayout
          minimize={this.props.minimizeSidebar}
          sidebarWidth={cookieSidebarWidth ? cookieSidebarWidth : window.outerWidth > 1400 ? '700px' : '650px'}
          mainContent={
            <MainContent
              mapService={this.state.mapService}
              onMapServiceReady={mapService => {
                this.setState({...this.state, mapService}, () => {
                  this.stateOrPropsChanged(this.props, this.state)
                })
              }}
            />
          }
          sidebarContent={
            this.state.mapService && this.props.user
              ? (long: boolean) => <SidebarContent long={long} />
              : (long: boolean) => <div></div>
          }
          sidebarNavigation={
            this.state.mapService && this.props.user
              ? (navigationWidth: number) => <SidebarNavigation navigationWidth={navigationWidth} />
              : (navigationWidth: number) => <div></div>
          }
          setLong={this.props.setLong}
          mobile={window.innerWidth < 768}
          navigationWidth={60}
        />
      )
    }
    if (appConfig.isArchImport) {
      return (
        <Main
          mapComponent={
            <MainContent
              mapService={this.state.mapService}
              onMapServiceReady={mapService => {
                this.setState({...this.state, mapService}, () => {
                  mapService.updateSize()
                  setTimeout(() => {
                    mapService.updateSize()
                    setTimeout(() => {
                      mapService.updateSize()
                    }, 1000)
                  }, 1000)
                  this.stateOrPropsChanged(this.props, this.state)
                })
              }}
            />
          }
        />
      )
    }
    return (
      <MainContent
        mapService={this.state.mapService}
        onMapServiceReady={mapService => {
          this.setState({...this.state, mapService}, () => {
            this.stateOrPropsChanged(this.props, this.state)
          })
        }}
      />
    )
  }

  render() {
    let desc = ''
    switch (window.appType) {
      case 'public':
        desc = 'Публичен ГИС'
        break
      case 'admin':
        desc = 'Административен модул'
        break
      default:
        desc = 'Гис'
        break
    }

    const el = document.querySelector("meta[name='description']")
    if (el) {
      el.setAttribute('content', desc)
    }

    return (
      <div className="main">
        <FixedPopupRenderer popupDispatcher={this.props} />
        {this.state.mapService ? (
          <AppHeader
            user={this.props.user}
            mobile={window.innerWidth < 768}
            onLogout={() => {
              this.recoverAttempted = false
              this.props.signOut()
            }}
          />
        ) : null}
        {this.getContent()}
      </div>
    )
  }
}

const mapStateToProps = (state: IAppStore) => {
  return {
    mobile: state.application.mobile,
    sourcesImported: state.map.sourcesImported,
    minimizeSidebar: state.sidebar.minimize,
    layerInfos: state.layerInfos.featureLayerInfos,
    user: state.userInfo.user
  }
}

export default connect<OwnProps, DispatchProps>(mapStateToProps, {
  ...appMapDispatcher,
  ...appFeatureTablesDispatcher,
  tryRecoverCredentials,
  signOut,
  ...appSidebarDispatcher,
  ...appPopupDispatcher,
  ...appSourcesDispatcher
})(App)
